import {useState} from 'react';
import {Button, Modal, Form, Input, Radio, App} from 'antd';
import axios from 'axios';

// Extend Window interface to include uuid
declare global {
    interface Window {
        uuid: string;
    }
}

type Props = {
    playerType: 'player' | 'substitute';
    visible: boolean;
    onCancel: () => void;
    onSuccess: (data: any) => void;
};

export default function ModalForm({playerType, visible, onCancel, onSuccess}: Props) {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const {message: messageApi} = App.useApp();

    return (
        <Modal footer={null} open={visible} title='Bæta einstakling í hópinn' onCancel={onCancel}>
            <p>Við mælum sterklega með því að þú fyllir út símanúmer og/eða netfang leikmanns, en það er þó ekki nauðsynlegt. </p>
            <p>Bæði svo hægt sé að senda áminningar varðandi mætingu og hinsvegar svo að viðkomandi get eignað sér leikmanninn þegar hann eða hún býr til aðgang.</p>
            <br />
            {playerType && (
                <Form
                    initialValues={{player_type: playerType}}
                    form={form}
                    onFinish={(values) => {
                        setLoading(true);

                        const email = values.unconfirmed_email || '';
                        let phone = values.unconfirmed_phone || '';
                        const name = values.unconfirmed_name;

                        if (phone) phone = encodeURIComponent('+354' + phone);

                        axios
                            .get('/api/get_or_create_player/?email=' + email + '&phone=' + phone + '&name=' + name)
                            .then((rsp) => {
                                axios
                                    .post('/api/add_remove_player_to_team_list/', {
                                        player: rsp.data.uuid,
                                        team: window.uuid,
                                        list_name: values.player_type + 's',
                                        action: 'add',
                                    })
                                    .then((res) => {
                                        onSuccess(rsp.data);
                                        setLoading(false);

                                        messageApi.success('Jibbí, ' + values.unconfirmed_name + ' hefur verið bætt við liðið!');
                                        form.setFieldsValue({
                                            unconfirmed_name: null,
                                            unconfirmed_email: null,
                                            unconfirmed_phone: null,
                                        });
                                    })
                                    .catch((error) => {
                                        if (error.response?.status === 403) {
                                            messageApi.error('Þú hefur ekki leyfi til að framkvæma þessa aðgerð!');
                                        } else {
                                            setLoading(false);
                                            messageApi.error('Úps eitthvað fór úrskeiðis, ekki tókst að bæta leikmanni við :(');
                                        }
                                    });
                            })
                            .catch((err) => {
                                if (err.response?.status === 403) {
                                    messageApi.error('Þú hefur ekki leyfi til að framkvæma þessa aðgerð!');
                                } else {
                                    messageApi.error('Úps eitthvað fór úrskeiðis, ekki tókst að bæta leikmanni við :(');
                                    setLoading(false);
                                }
                            });
                    }}
                    layout='vertical'
                    name='basic'
                >
                    <Form.Item
                        label='Nafn'
                        name='unconfirmed_name'
                        rules={[
                            {
                                required: true,
                                message: 'Nafn er ekki valkvætt!',
                            },
                        ]}
                    >
                        <Input size='large' autoComplete='new-password' />
                    </Form.Item>

                    <Form.Item label='Netfang' name='unconfirmed_email'>
                        <Input size='large' autoComplete='new-password' />
                    </Form.Item>

                    <Form.Item
                        label='Símanúmer'
                        name='unconfirmed_phone'
                        rules={[
                            {
                                validator: (rule, value) => {
                                    return !value || value.length === 7 ? Promise.resolve() : Promise.reject('Símanúmerið þarf að vera 7 stafir');
                                },
                            },
                        ]}
                    >
                        <Input size='large' autoComplete='new-password' />
                    </Form.Item>

                    <Form.Item name='player_type'>
                        <Radio.Group defaultValue={playerType} optionType='button' buttonStyle='solid'>
                            <Radio.Button value='player'>Aðal hópur</Radio.Button>

                            <Radio.Button value='substitute'>Varamannabekkurinn</Radio.Button>
                        </Radio.Group>
                    </Form.Item>

                    <Form.Item>
                        <Button block size='large' loading={loading} type='primary' htmlType='submit'>
                            Vista
                        </Button>
                    </Form.Item>
                </Form>
            )}
        </Modal>
    );
}
